/**
 * propertyType
 * proposedPropertyType
 */
export const selectOptionsPipelineType = [
  "Commercial",
  "Scenario",
  "Underwriting",
];
